export default function getErrorMessage(intl, msg) {
  const errorList = {
    "The email has been registered.": intl.formatMessage({
      id: "This email has already been registered.",
      defaultMessage: "This email has already been registered.",
    }),
    "Invalid Recaptcha!": intl.formatMessage({
      id: "Invalid Recaptcha!",
      defaultMessage: "Invalid Recaptcha!",
    }),
  };
  return errorList[msg];
}
